import { NgModule } from '@angular/core';

import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
	imports: [
		AccordionModule,
		ChartModule,
		TooltipModule,
		ButtonModule,
		ProgressBarModule,
		InputTextModule,
		SelectButtonModule,
		InputTextareaModule,
		MultiSelectModule,
		TabViewModule,
		TableModule,
		OverlayPanelModule,
		CheckboxModule,
		DropdownModule,
		ProgressSpinnerModule,
		DynamicDialogModule,
		MenuModule,
		CardModule,
		ToastModule,
		InplaceModule,
		CalendarModule,
		ListboxModule,
		ConfirmDialogModule,
		RadioButtonModule,
		SplitButtonModule,
		DialogModule,
		RatingModule,
		ScrollPanelModule,
		InputSwitchModule,
		InputMaskModule,
	],
	exports: [
		AccordionModule,
		ChartModule,
		TooltipModule,
		ButtonModule,
		SelectButtonModule,
		ProgressBarModule,
		InputTextModule,
		InputTextareaModule,
		MultiSelectModule,
		TabViewModule,
		TableModule,
		OverlayPanelModule,
		CheckboxModule,
		DropdownModule,
		ProgressSpinnerModule,
		DynamicDialogModule,
		MenuModule,
		CardModule,
		ToastModule,
		InplaceModule,
		CalendarModule,
		ListboxModule,
		ConfirmDialogModule,
		RadioButtonModule,
		SplitButtonModule,
		DialogModule,
		RatingModule,
		ScrollPanelModule,
		InputSwitchModule,
		InputMaskModule,
	],
	providers: [MessageService, ConfirmationService],
})
export class AppPrimengModule {}
